<template>
  <fh-container justify-center fluid>
    <v-card>
      <v-card-title primary-title>
        <div class="text-md-h5 text-subtitle-1 text-break text-center">
          Administración
        </div>
      </v-card-title>
      <v-card-text>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="primary"
          grow
        >
          <v-tab v-for="item in tabs" :key="item">
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items touchless v-model="tab">
          <v-tab-item>
            <v-card flat>
              <!-- Definición Conceptos -->
              <v-card-text class="px-0" id="conceptos">
                <!-- <fh-intersection-observer :options="optionsConcepto" @intersect="intersected('conceptos')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="header"
                    :items="conceptosSaved"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición Conceptos</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="dialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nuevo Concepto
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" sm="6">
                                        <v-text-field
                                          v-model="editedConcepto.nombre"
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="conceptoref"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col>
                                        <v-radio-group
                                          v-model="editedConcepto.tipo"
                                          column
                                          class="mt-0 pt-0"
                                          mandatory
                                        >
                                          <v-radio
                                            label="Ingreso"
                                            :value="2"
                                            class="mb-2 pl-4"
                                          ></v-radio>
                                          <v-radio
                                            label="Gasto"
                                            :value="1"
                                            class="my-2 pl-4"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>
                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="close"
                                      class=""
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn color="primary" text @click="save">
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col v-if="editedIndex < 0" class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateConcepto"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <!-- <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="close"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                v-if="editedIndex < 0"
                                color="primary"
                                text
                                outlined
                                @click="saveAndCreateConcepto"
                              >
                                Guardar y seguir agregando
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="save"
                              >
                                Guardar
                              </v-btn>
                            </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog v-model="dialogDelete" max-width="500px">
                          <v-card>
                            <v-card-title class="text-h5"
                              >¿Está seguro que quiere eliminar este
                              concepto?</v-card-title
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="black" text @click="closeDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteConceptoConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.tipo`]="{ item }">
                      <template v-if="item.tipo === 1">
                        {{ "Gasto" }}
                      </template>
                      <template v-else-if="item.tipo === 2">
                        {{ "Ingreso" }}
                      </template>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-5" @click="editConcepto(item)">
                        fa-pen
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
              <!-- Definición Subconceptos -->
              <v-card-text class="px-0" id="subconceptos">
                <!-- <fh-intersection-observer :options="optionsSubconceptos" @intersect="intersected('subconceptos')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-toolbar flat>
                    <v-row class="pt-5">
                      <v-col class="py-0">
                        <v-toolbar-title class="black--text"
                          >Definición Subconceptos</v-toolbar-title
                        >
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-dialog
                        v-model="subDialog"
                        max-width="500px"
                        persistent
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-col class="py-0">
                            <v-btn
                              color="primary"
                              dark
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              Nuevo Subconcepto
                            </v-btn>
                          </v-col>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="text-h5">{{ formTitleSub }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-form ref="form" v-model="valid">
                              <v-container>
                                <v-row>
                                  <v-col class="py-0" cols="12">
                                    <v-autocomplete
                                      v-model="editedSubConcepto.idConcepto"
                                      :items="conceptos"
                                      item-text="nombre"
                                      item-value="idConcepto"
                                      outlined
                                      label="Concepto"
                                      :rules="completeRules"
                                      autofocus
                                      ref="selectConcepto"
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col cols="12" class="py-0">
                                    <v-text-field
                                      v-model="editedSubConcepto.nombre"
                                      label="Nombre"
                                      :rules="commonRules"
                                      :counter="nombreLength"
                                      outlined
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" class="py-0">
                                    <fh-number
                                      v-model="editedSubConcepto.codigo"
                                      label="Codigo del Subconcepto"
                                      maximumFractionDigits="0"
                                      outlined
                                      :rules="nonNegativeRules"
                                    ></fh-number>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      label="¿Asociable a una parcela?"
                                      v-model="editedSubConcepto.indicarParcela"
                                      class="mt-0 pt-0 pr-6"
                                      :false-value="false"
                                      :true-value="true"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      label="¿Es relacionado a la producción?"
                                      v-model="
                                        editedSubConcepto.esRelacionadoProduccion
                                      "
                                      class="mt-0 pt-0 pr-6"
                                      :false-value="false"
                                      :true-value="true"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </v-card-text>

                          <v-card-text>
                            <v-row class="text-center">
                              <v-col class="py-0">
                                <v-btn
                                  color="black"
                                  text
                                  @click="closeSubConcepto"
                                >
                                  Cancelar
                                </v-btn>
                              </v-col>
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  text
                                  @click="saveSubConcepto"
                                >
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col v-if="subEditedIndex < 0" class="py-0">
                                <v-btn
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateSub"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <!-- <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="closeSubConcepto"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn
                                v-if="subEditedIndex < 0"
                                color="primary"
                                text
                                outlined
                                @click="saveAndCreateSub"
                              >
                                Guardar y seguir agregando
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                @click="saveSubConcepto"
                              >
                                Guardar
                              </v-btn>
                            </v-card-actions> -->
                        </v-card>
                      </v-dialog>
                    </v-row>
                    <v-dialog v-model="dialogSubDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5 text-break text-center"
                          >¿Está seguro que quiere eliminar este subconcepto?
                        </v-card-title>
                        <v-card-text class="text-center text-h6 text-break"
                          ><div class="red--text">
                            {{ editedSubConcepto.codigo }} -
                            {{ editedSubConcepto.nombre }}
                          </div></v-card-text
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="black" text @click="closeDeleteSub"
                            >Cancelar</v-btn
                          >
                          <v-btn
                            color="error"
                            text
                            @click="deleteSubConceptoConfirm"
                            >Eliminar</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                  <v-card-text>
                    <div class="fh-scroll">
                      <table class="text-right fh-striped-table text-no-wrap">
                        <tbody>
                          <template
                            v-for="(
                              concepto, indexC
                            ) in listaConceptosOrdenados"
                          >
                            <tr :key="'csc-' + indexC" class="black--text">
                              <th class="text-left">
                                {{
                                  getConceptoById(concepto.idConcepto).nombre
                                }}
                              </th>
                              <!-- <th class="text-left" >{{concepto.tipo === 1 ? 'Gasto' : 'Ingreso'}}</th> -->
                            </tr>

                            <tr :key="'csch-' + indexC" class="black--text">
                              <th class="text-left">Código</th>
                              <th class="text-left" colspan="2">Nombre</th>
                              <th class="text-left">Relacionado</th>
                            </tr>

                            <template v-for="sub in concepto.subConceptos">
                              <tr class="black--text" :key="sub.idSubconcepto">
                                <td class="text-left">{{ sub.codigo }}</td>
                                <td class="text-left" colspan="2">
                                  {{ sub.nombre }}
                                </td>
                                <td class="text-left" colspan="2">
                                  {{
                                    sub.indicarParcela
                                      ? "Relacionado con Parcela "
                                      : "Normal"
                                  }}
                                </td>
                                <td>
                                  <v-icon
                                    small
                                    class="mr-5"
                                    @click="editSubConcepto(concepto, sub)"
                                  >
                                    fa-pen
                                  </v-icon>
                                  <v-icon
                                    small
                                    @click="deleteSubConcepto(concepto, sub)"
                                    color="error"
                                  >
                                    fa-trash
                                  </v-icon>
                                </td>
                              </tr>
                            </template>
                            <tr :key="'csc2-' + indexC">
                              <td class="fh-empty-row"></td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <!-- Definicion Tipo movimiento -->
              <v-card-text class="px-0" id="tipomovimiento">
                <!-- <fh-intersection-observer :options="optionsTipos" @intersect="intersected('tipomovimiento')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="headerTipo"
                    :items="listaTipoMovimientoAnimal"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición tipo movimiento
                              animal</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="tipoDialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nuevo tipo movimiento animal
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5">{{
                                  formTipoMovimientoTitle
                                }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="editedTipoMovimiento.nombre"
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="tiporef"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-radio-group
                                          v-model="editedTipoMovimiento.tipo"
                                          column
                                          class="mt-0 pt-0"
                                          mandatory
                                          label="Tipo de movimiento"
                                        >
                                          <v-radio
                                            label="Entrada"
                                            :value="1"
                                            class="mb-2 pl-4"
                                          ></v-radio>
                                          <v-radio
                                            label="Salida"
                                            :value="2"
                                            class="my-2 pl-4"
                                          ></v-radio>
                                          <v-radio
                                            label="Transferencia"
                                            :value="3"
                                            class="my-2 pl-4"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-autocomplete
                                          v-model="editedTipoMovimiento.codigo"
                                          :items="codigoEnum"
                                          item-text="codigo"
                                          item-value="id"
                                          outlined
                                          label="Código"
                                          :rules="completeRules"
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col class="py-0">
                                        <v-checkbox
                                          label="Indicar Importe"
                                          v-model="
                                            editedTipoMovimiento.indicarImporte
                                          "
                                          class="mt-0 pt-0 pr-6"
                                          :false-value="false"
                                          :true-value="true"
                                        >
                                        </v-checkbox>
                                      </v-col>
                                      <v-col
                                        class="py-0"
                                        cols="12"
                                        v-if="
                                          editedTipoMovimiento.indicarImporte
                                        "
                                      >
                                        <div class="text--secondary">
                                          ¿Relacionar importe con subconceptos?
                                        </div>
                                      </v-col>
                                      <v-col
                                        class="pb-0"
                                        cols="12"
                                        v-if="
                                          editedTipoMovimiento.indicarImporte
                                        "
                                      >
                                        <v-autocomplete
                                          v-model="
                                            editedTipoMovimiento.subconceptosImporte
                                          "
                                          :items="listaSubc"
                                          item-text="nombre"
                                          return-object
                                          outlined
                                          label="Subconcepto"
                                          :rules="completeRules"
                                          persistent-hint
                                          multiple
                                          chips
                                          @change="t++"
                                        >
                                          <template v-slot:selection="data">
                                            <v-chip
                                              v-bind="data.attrs"
                                              :input-value="data.selected"
                                              close
                                              @click="data.select"
                                              @click:close="
                                                removeSubconcepto(data.item)
                                              "
                                            >
                                              {{ data.item.nombre }}
                                            </v-chip>
                                          </template>
                                        </v-autocomplete>
                                      </v-col>
                                      <v-col
                                        :key="t"
                                        cols="12"
                                        class="py-0"
                                        v-if="
                                          editedTipoMovimiento.indicarImporte &&
                                          editedTipoMovimiento.subconceptosImporte &&
                                          editedTipoMovimiento
                                            .subconceptosImporte.length !== 0
                                        "
                                      >
                                        <div class="text--secondary pb-2">
                                          ¿Cargar registro sólo en movimientos
                                          financieros?
                                        </div>
                                        <v-checkbox
                                          v-for="sub in editedTipoMovimiento.subconceptosImporte"
                                          :key="sub.idSubconcepto"
                                          :label="sub.nombre"
                                          v-model="
                                            sub.soloCargaMovimientoFinciero
                                          "
                                          class="mt-0 pt-0 pr-6"
                                          :false-value="false"
                                          :true-value="true"
                                        >
                                        </v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="closeTipo"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="saveTipo"
                                    >
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col
                                    v-if="tipoEditedIndex < 0"
                                    class="py-0"
                                  >
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateTipo"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="black"
                                  text
                                  @click="closeTipo"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  v-if="tipoEditedIndex < 0"
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateTipo"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="saveTipo"
                                >
                                  Guardar
                                </v-btn>
                              </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog v-model="dialogTipoDelete" max-width="500px">
                          <v-card>
                            <v-card-title class="text-h5 text-break"
                              >¿Está seguro que quiere eliminar este tipo de
                              movimiento animal?</v-card-title
                            >
                            <v-card-text
                              class="text-center text-h5 red--text"
                              >{{ editedTipoMovimiento.nombre }}</v-card-text
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="black" text @click="closeTipoDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteTipoConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.tipo`]="{ item }">
                      {{ tipoEnum[item.tipo - 1].tipo }}
                    </template>
                    <template v-slot:[`item.indicarImporte`]="{ item }">
                      <template v-if="item.indicarImporte === 1">
                        {{ "Sí" }}
                      </template>
                      <template v-else>
                        {{ "No" }}
                      </template>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        class="mr-5"
                        @click="editTipoMovimiento(item)"
                      >
                        fa-pen
                      </v-icon>
                      <v-icon
                        small
                        @click="deleteTipoMovimientoAnimal(item)"
                        color="error"
                      >
                        fa-trash
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
              <!-- Definición categoria animal -->
              <v-card-text class="px-0" id="categoria">
                <!-- <fh-intersection-observer :options="optionsCategoria" @intersect="intersected('categoria')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="headerCategoria"
                    :items="listaCategoriaAnimal"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición categoría animal</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="categoriaDialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nueva categoría de animal
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5">{{
                                  formCategoriaTitle
                                }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="editedCategoria.nombre"
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="categoriasref"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-radio-group
                                          v-model="editedCategoria.sexo"
                                          column
                                          class="mt-0 pt-0"
                                          mandatory
                                          label="Tipo de movimiento"
                                        >
                                          <v-radio
                                            label="Macho"
                                            :value="1"
                                            class="mb-2 pl-4"
                                          ></v-radio>
                                          <v-radio
                                            label="Hembra"
                                            :value="2"
                                            class="my-2 pl-4"
                                          ></v-radio>
                                        </v-radio-group>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-autocomplete
                                          v-model="
                                            editedCategoria.clasificacion
                                          "
                                          :items="clasificacion"
                                          item-text="text"
                                          item-value="id"
                                          outlined
                                          label="Clasificación"
                                          :rules="completeRules"
                                        ></v-autocomplete>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="closeCategoria"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="saveCategoria"
                                    >
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col
                                    v-if="categoriaEditedIndex < 0"
                                    class="py-0"
                                  >
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateCategorias"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="black"
                                  text
                                  @click="closeCategoria"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  v-if="categoriaEditedIndex < 0"
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateCategorias"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="saveCategoria"
                                >
                                  Guardar
                                </v-btn>
                              </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog
                          v-model="dialogCategoriaDelete"
                          max-width="500px"
                        >
                          <v-card>
                            <v-card-title class="text-h5 text-break"
                              >¿Está seguro que quiere eliminar esta categoría
                              de animal?</v-card-title
                            >
                            <v-card-text
                              class="text-center text-h5 red--text"
                              >{{ editedCategoria.nombre }}</v-card-text
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="closeCategoriaDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteCategoriaConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.clasificacion`]="{ item }">
                      {{ clasificacion[item.clasificacion - 1].text }}
                    </template>
                    <template v-slot:[`item.sexo`]="{ item }">
                      <template v-if="item.sexo === 1">
                        {{ "Macho" }}
                      </template>
                      <template v-else>
                        {{ "Hembra" }}
                      </template>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon small class="mr-5" @click="editCategoria(item)">
                        fa-pen
                      </v-icon>
                      <v-icon
                        small
                        @click="deleteCategoria(item)"
                        color="error"
                      >
                        fa-trash
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
              <!-- Defnición subcategoria animal -->
              <v-card-text class="px-0" id="subcategoria">
                <!-- <fh-intersection-observer :options="optionsSubcategoria" @intersect="intersected('subcategoria')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="headerSubcategoria"
                    :items="listaSubCategoriaAnimal"
                    hide-default-footer
                    :items-per-page="-1"
                    :sort-by="['categoriaAnimal.nombre']"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición subcategoría animal</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="subCategoriaDialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nueva subcategoría animal
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5 text-break">{{
                                  formSubCategoriaTitle
                                }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-text-field
                                          v-model="editedSubCategoria.nombre"
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="subcategoriaref"
                                        ></v-text-field>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-autocomplete
                                          v-model="
                                            editedSubCategoria.idCategoriaAnimal
                                          "
                                          :items="listaCategoriaAnimal"
                                          item-text="nombre"
                                          item-value="idCategoriaAnimal"
                                          outlined
                                          label="Categoría Animal"
                                          :rules="completeRules"
                                        ></v-autocomplete>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <v-checkbox
                                          label="Es reproductivo"
                                          v-model="
                                            editedSubCategoria.esReproductivo
                                          "
                                          class="mt-0 pt-0 pr-6"
                                          :false-value="false"
                                          :true-value="true"
                                        >
                                        </v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="closeSubcategoria"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="saveSubcategoria"
                                    >
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col
                                    v-if="subCategoriaEditedIndex < 0"
                                    class="py-0"
                                  >
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateSubcategoria"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="black"
                                  text
                                  @click="closeSubcategoria"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  v-if="subCategoriaEditedIndex < 0"
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateSubcategoria"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="saveSubcategoria"
                                >
                                  Guardar
                                </v-btn>
                                <v-spacer></v-spacer>
                              </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog
                          v-model="dialogSubCategoriaDelete"
                          max-width="500px"
                        >
                          <v-card>
                            <v-card-title class="text-h5 text-break"
                              >¿Está seguro que quiere eliminar esta
                              subcategoría de animales?</v-card-title
                            >
                            <v-card-text
                              class="text-center text-h5 red--text"
                              >{{ editedSubCategoria.nombre }}</v-card-text
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="closeSubcategoriaDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteSubcategoriaConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.categoriaAnimal.sexo`]="{ item }">
                      <template v-if="item.categoriaAnimal.sexo === 1">
                        {{ "Macho" }}
                      </template>
                      <template v-else>
                        {{ "Hembra" }}
                      </template>
                    </template>
                    <template v-slot:[`item.esReproductivo`]="{ item }">
                      <template v-if="item.esReproductivo === 1">
                        {{ "Sí" }}
                      </template>
                      <template v-else>
                        {{ "No" }}
                      </template>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        class="mr-5"
                        @click="editSubcategoria(item)"
                      >
                        fa-pen
                      </v-icon>
                      <v-icon
                        small
                        @click="deleteSubcategoria(item)"
                        color="error"
                      >
                        fa-trash
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
              <!-- Defnición parametros recategorización -->
              <v-card-text class="px-0" id="paramrec">
                <!-- <fh-intersection-observer :options="optionsSubcategoria" @intersect="intersected('subcategoria')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-toolbar flat>
                    <v-row class="pt-5">
                      <v-col class="py-0">
                        <v-toolbar-title class="black--text"
                          >Definición parám. de
                          recategorización</v-toolbar-title
                        >
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-dialog
                        v-model="recDialog"
                        max-width="600px"
                        persistent
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-col class="py-0">
                            <v-btn
                              color="primary"
                              dark
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              Nuevo parám. recategorización
                            </v-btn>
                          </v-col>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="text-h5 text-break">{{
                              formRecTitle
                            }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-form ref="form" v-model="valid">
                              <!-- <v-container> -->
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedRec.nombre"
                                    label="Nombre"
                                    :rules="commonRules"
                                    :counter="nombreLength"
                                    outlined
                                    autofocus
                                    ref="recparam"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                  <v-autocomplete
                                    v-model="editedRec.idTipoMovimientoAnimal"
                                    :items="listaTipoMovimientoRecategorizacion"
                                    item-text="nombre"
                                    item-value="idTipoMovimientoAnimal"
                                    outlined
                                    label="Tipo Movimiento"
                                    :rules="completeRules"
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row class="mt-0" justify="center">
                                <v-col
                                  class="d-flex flex-column justify-center align-center"
                                >
                                  <v-subheader class="black--text"
                                    >Salidas</v-subheader
                                  >
                                </v-col>
                                <v-col cols="1"></v-col>
                                <v-col
                                  class="d-flex flex-column justify-center align-center"
                                >
                                  <v-subheader class="black--text"
                                    >Entradas</v-subheader
                                  >
                                </v-col>
                              </v-row>
                              <v-row
                                class="mt-0"
                                justify="center"
                                align="center"
                              >
                                <v-col
                                  class="d-flex flex-column justify-center align-center"
                                >
                                  <v-autocomplete
                                    v-model="editedRec.reglasSalida"
                                    :items="listaCategoriaAnimal"
                                    item-text="nombre"
                                    item-value="idCategoriaAnimal"
                                    outlined
                                    label="Categoría Animal"
                                    :rules="completeRules"
                                    hint="Salen de las categorías..."
                                    persistent-hint
                                    multiple
                                    chips
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        close
                                        @click="data.select"
                                        @click:close="removeSalida(data.item)"
                                      >
                                        {{ data.item.nombre }}
                                      </v-chip>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                  cols="1"
                                  class="d-flex flex-column justify-center align-center"
                                  ><v-icon class="pb-7"
                                    >fa-arrow-right</v-icon
                                  ></v-col
                                >
                                <v-col
                                  class="d-flex flex-column justify-center align-center"
                                >
                                  <v-autocomplete
                                    v-model="editedRec.reglasEntrada"
                                    :items="listaCategoriaAnimal"
                                    item-text="nombre"
                                    item-value="idCategoriaAnimal"
                                    outlined
                                    label="Categoría Animal"
                                    :rules="completeMultipleRules"
                                    hint="Entran en las categorías..."
                                    persistent-hint
                                    multiple
                                    chips
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        close
                                        @click="data.select"
                                        @click:close="removeEntrada(data.item)"
                                      >
                                        {{ data.item.nombre }}
                                      </v-chip>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                              <!-- </v-container> -->
                            </v-form>
                          </v-card-text>

                          <v-card-text>
                            <v-row class="text-center">
                              <v-col class="py-0">
                                <v-btn color="black" text @click="closeRec">
                                  Cancelar
                                </v-btn>
                              </v-col>
                              <v-col class="py-0">
                                <v-btn color="primary" text @click="saveRec">
                                  Guardar
                                </v-btn>
                              </v-col>
                              <v-col v-if="recEditedIndex < 0" class="py-0">
                                <v-btn
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateRec"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>

                          <!-- <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="black"
                              text
                              @click="closeRec"
                            >
                              Cancelar
                            </v-btn>
                            <v-btn
                              v-if="recEditedIndex < 0"
                              color="primary"
                              text
                              outlined
                              @click="saveAndCreateRec"
                            >
                              Guardar y seguir agregando
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click="saveRec"
                            >
                              Guardar
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions> -->
                        </v-card>
                      </v-dialog>
                    </v-row>
                    <v-dialog v-model="dialogRecDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5 text-break"
                          >¿Está seguro que quiere eliminar este parám. de
                          recategorización?</v-card-title
                        >
                        <v-card-text class="text-center text-h5 red--text">{{
                          editedRec.nombre
                        }}</v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="black" text @click="closeRecDelete"
                            >Cancelar</v-btn
                          >
                          <v-btn color="error" text @click="deleteRecConfirm"
                            >Eliminar</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                  <v-row class="mt-0" justify="center">
                    <v-col
                      class="d-flex flex-column justify-center align-center"
                    >
                      <v-subheader class="black--text"
                        ><div class="text-h6">Salidas</div></v-subheader
                      >
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col
                      class="d-flex flex-column justify-center align-center"
                    >
                      <v-subheader class="black--text"
                        ><div class="text-h6">Entradas</div></v-subheader
                      >
                    </v-col>
                  </v-row>
                  <v-card
                    outlined
                    class="mx-2 mb-2"
                    v-for="(
                      param, paramIndex
                    ) in listaParametrosRecategorizacion"
                    :key="paramIndex"
                  >
                    <v-card-title
                      ><div class="text-subtitle-2">
                        {{ param.nombre }}
                      </div></v-card-title
                    >
                    <v-card-text>
                      <v-row>
                        <v-col
                          class="d-flex flex-column justify-start align-center"
                        >
                          <template v-for="(regla, reglaIndex) in param.reglas">
                            <div
                              class="black--text"
                              v-if="regla.tipo === 2"
                              :key="reglaIndex + 'regla' + paramIndex"
                            >
                              {{ regla.categoriaAnimal.nombre }}
                            </div>
                          </template>
                        </v-col>
                        <v-col
                          cols="1"
                          class="d-flex flex-column justify-center align-center"
                          ><v-icon class="">fa-arrow-right</v-icon></v-col
                        >
                        <v-col
                          class="d-flex flex-column justify-start align-center"
                        >
                          <template v-for="(regla, reglaIndex) in param.reglas">
                            <div
                              class="black--text"
                              v-if="regla.tipo === 1"
                              :key="reglaIndex + 'regla' + paramIndex"
                            >
                              {{ regla.categoriaAnimal.nombre }}
                            </div>
                          </template>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn icon small @click="editarRec(param)">
                        <v-icon small>fa-pen</v-icon>
                      </v-btn>

                      <v-btn icon small @click="deleteRec(param)">
                        <v-icon small color="error">fa-trash</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-card-text>
              <!-- Definición metodos de reproduccion -->
              <v-card-text class="px-0" id="metreproduccion">
                <!-- <fh-intersection-observer :options="optionsTipos" @intersect="intersected('metreproduccion')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="headerMetodoReproduccion"
                    :items="listaMetodoReproduccion"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición métodos de
                              reproducción</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="metRepDialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nuevo método de reproducción
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5 text-break">{{
                                  formMetodoReproduccionTitle
                                }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" class="px-0">
                                        <v-text-field
                                          v-model="
                                            editedMetodoReproduccion.nombre
                                          "
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="metref"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="closeMetRep"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="saveMetRep"
                                    >
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col
                                    v-if="metRepEditedIndex < 0"
                                    class="py-0"
                                  >
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateMetRep"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>

                              <!-- <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="black"
                                  text
                                  @click="closeMetRep"
                                >
                                  Cancelar
                                </v-btn>
                                <v-btn
                                  v-if="metRepEditedIndex < 0"
                                  color="primary"
                                  text
                                  outlined
                                  @click="saveAndCreateMetRep"
                                >
                                  Guardar y seguir agregando
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="saveMetRep"
                                >
                                  Guardar
                                </v-btn>
                              </v-card-actions> -->
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog
                          v-model="dialogMetRepDelete"
                          max-width="500px"
                        >
                          <v-card>
                            <v-card-title class="text-h5 text-break"
                              >¿Está seguro que quiere eliminar este método de
                              reproducción?</v-card-title
                            >
                            <v-card-text
                              class="text-center text-h5 red--text"
                              >{{
                                editedMetodoReproduccion.nombre
                              }}</v-card-text
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="closeMetRepDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteMetRepConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        class="mr-5"
                        @click="editMetodoReproduccion(item)"
                      >
                        fa-pen
                      </v-icon>
                      <v-icon
                        small
                        @click="deleteMetReproduccion(item)"
                        color="error"
                      >
                        fa-trash
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
              <!-- Definición categorias de reproducción -->
              <v-card-text class="px-0" id="catreproduccion">
                <!-- <fh-intersection-observer :options="optionsTipos" @intersect="intersected('catreproduccion')"></fh-intersection-observer> -->
                <v-card flat outlined>
                  <v-data-table
                    :headers="headerCategoriaReproduccion"
                    :items="listaCategoriaReproduccion"
                    hide-default-footer
                    :items-per-page="-1"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-row class="pt-5">
                          <v-col class="py-0">
                            <v-toolbar-title class="black--text"
                              >Definición categorías de
                              reproducción</v-toolbar-title
                            >
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="catRepDialog"
                            max-width="500px"
                            persistent
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col class="py-0">
                                <v-btn
                                  color="primary"
                                  dark
                                  class="mb-2"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  Nueva categoría de reproducción
                                </v-btn>
                              </v-col>
                            </template>
                            <v-card>
                              <v-card-title>
                                <span class="text-h5 text-break">{{
                                  formCategoriaReproduccionTitle
                                }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-form ref="form" v-model="valid">
                                  <v-container>
                                    <v-row>
                                      <v-col cols="12" class="px-0">
                                        <v-text-field
                                          v-model="
                                            editedCategoriaReproduccion.nombre
                                          "
                                          label="Nombre"
                                          :rules="commonRules"
                                          :counter="nombreLength"
                                          outlined
                                          autofocus
                                          ref="catref"
                                        ></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </v-card-text>

                              <v-card-text>
                                <v-row class="text-center">
                                  <v-col class="py-0">
                                    <v-btn
                                      color="black"
                                      text
                                      @click="closeCatRep"
                                    >
                                      Cancelar
                                    </v-btn>
                                  </v-col>
                                  <v-col class="py-0">
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="saveCatRep"
                                    >
                                      Guardar
                                    </v-btn>
                                  </v-col>
                                  <v-col
                                    v-if="catRepEditedIndex < 0"
                                    class="py-0"
                                  >
                                    <v-btn
                                      color="primary"
                                      text
                                      outlined
                                      @click="saveAndCreateCatRep"
                                    >
                                      Guardar y seguir agregando
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </v-row>
                        <v-dialog
                          v-model="dialogCatRepDelete"
                          max-width="500px"
                        >
                          <v-card>
                            <v-card-title class="text-h5 text-break"
                              >¿Está seguro que quiere eliminar esta categoría
                              de reproducción?</v-card-title
                            >
                            <v-card-text
                              class="text-center text-h5 red--text"
                              >{{
                                editedCategoriaReproduccion.nombre
                              }}</v-card-text
                            >
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="black"
                                text
                                @click="closeCatRepDelete"
                                >Cancelar</v-btn
                              >
                              <v-btn
                                color="error"
                                text
                                @click="deleteCatRepConfirm"
                                >Eliminar</v-btn
                              >
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        class="mr-5"
                        @click="editCategoriaReproduccion(item)"
                      >
                        fa-pen
                      </v-icon>
                      <v-icon
                        small
                        @click="deleteCatReproduccion(item)"
                        color="error"
                      >
                        fa-trash
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-tabs
                v-model="agriculturaAdminTab"
                dark
                color="primary"
                show-arrows
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab v-for="header in configsAgricultura" :key="header">
                  {{ header }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="agriculturaAdminTab">
                <v-tab-item v-for="tab in configsAgricultura" :key="tab">
                  <v-card flat>
                    <v-card-text>
                      <admin-agro-variedades v-if="tab === 'Variedades'" />
                      <admin-configuraciones
                        v-if="tab === 'Productos Senave'"
                      />
                      <admin-agro-productos-cultivo
                        v-if="tab === 'Producto cultivo'"
                      ></admin-agro-productos-cultivo>
                      <admin-agro-cultivo
                        v-if="tab === 'Cultivos'"
                      ></admin-agro-cultivo>
                      <admin-agro-unidades-medida
                        v-if="tab === 'Unidades medida'"
                      ></admin-agro-unidades-medida>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </fh-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FhContainer from "@/components/FhContainer.vue";
import FhNumber from "@/components/FhNumber.vue";
import AdminConfiguraciones from "@/views/agro/configuraciones/AdminConfiguraciones.vue";
import FhIntersectionObserver from "@/components/FhIntersectionObserver.vue";
import ConfiguracionRepository from "@/services/ConfiguracionRepository";
import cloneDeep from "lodash.clonedeep";
import { GlobalEventEmitter } from "@/GlobalEventEmitter";
import AdminAgroVariedades from "./agro/configuraciones/AdminAgroVariedades.vue";
import AdminAgroProductosCultivo from "@/views/agro/configuraciones/AdminAgroProductoCultivo.vue";
import AdminAgroCultivo from "@/views/agro/configuraciones/AdminAgroCultivo.vue";
import AdminAgroUnidadesMedida from "@/views/agro/configuraciones/AdminAgroUnidadesMedida.vue";

export default {
  name: "AdministrarConceptos",
  components: {
    FhContainer,
    FhNumber,
    FhIntersectionObserver,
    AdminConfiguraciones,
    AdminAgroVariedades,
    AdminAgroCultivo,
    AdminAgroProductosCultivo,
    AdminAgroUnidadesMedida,
  },

  data() {
    return {
      tab: null,
      // 'Agricultura',
      tabs: ["Ganadería", "Agricultura"],
      agriculturaAdminTab: null,
      configsAgricultura: [
        "Productos Senave",
        "Cultivos",
        "Variedades",
        "Producto cultivo",
        "Unidades medida",
      ],
      // optionsConcepto: {
      //   rootMargin: "0px",
      //   threshold: 0.5
      // },
      // optionsSubconceptos: {
      //   rootMargin: "-200px",
      //   threshold: 0.10
      // },
      // optionsTipos: {
      //   rootMargin: "0px",
      //   threshold: 0.5
      // },
      // optionsCategoria: {
      //   rootMargin: "0px",
      //   threshold: 0.5
      // },
      // optionsSubcategoria: {
      //   rootMargin: "0px",
      //   threshold: 0.5
      // },
      t: 0,

      // Administrar conceptos
      conceptosSaved: [],
      editedConcepto: {
        idConcepto: 0,
        nombre: "",
        tipo: 0,
      },
      defaultConcepto: {
        idConcepto: 0,
        nombre: "",
        tipo: 0,
      },
      header: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Tipo",
          align: "start",
          sortable: true,
          value: "tipo",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],

      // Administrar subconceptos
      subConceptosSaved: [],
      editedSubConcepto: {
        idConcepto: 0,
        idSubconcepto: 0,
        codigo: 0,
        esRelacionadoProduccion: false,
        indicarParcela: false,
        nombre: "",
      },
      defaultSubConcepto: {
        idConcepto: 0,
        idSubconcepto: 0,
        codigo: 0,
        esRelacionadoProduccion: false,
        indicarParcela: false,
        nombre: "",
      },

      // Administrar tipo movimientos
      editedTipoMovimiento: {
        tipo: 0,
        codigo: 0,
        indicarImporte: false,
        nombre: "",
        subconceptosImporte: [],
      },
      defaultTipoMovimiento: {
        tipo: 0,
        codigo: 0,
        indicarImporte: false,
        nombre: "",
        subconceptosImporte: [],
      },
      headerTipo: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Tipo",
          align: "start",
          sortable: false,
          value: "tipo",
        },
        {
          text: "Indicar Importe",
          align: "start",
          sortable: false,
          value: "indicarImporte",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],
      tipoEnum: [
        { tipo: "Entrada", id: 1 },
        { tipo: "Salida", id: 2 },
        { tipo: "Transferencia", id: 3 },
      ],
      codigoEnum: [
        { codigo: "Venta", id: 1 },
        { codigo: "Compra", id: 2 },
        { codigo: "Nacimiento", id: 3 },
        { codigo: "Destete", id: 4 },
        { codigo: "Mortandad", id: 5 },
        { codigo: "Traslado Salida", id: 6 },
        { codigo: "Traslado Entrada", id: 7 },
        { codigo: "Consumo Propio", id: 8 },
        { codigo: "Robo", id: 9 },
        { codigo: "Traslado Lote", id: 10 },
        { codigo: "Recategorización", id: 11 },
      ],

      // Administrar categoria
      editedCategoria: {
        idCategoriaAnimal: 0,
        nombre: "",
        sexo: 0,
        clasificacion: 0,
      },
      defaultCategoria: {
        idCategoriaAnimal: 0,
        nombre: "",
        sexo: 0,
        clasificacion: 0,
      },
      headerCategoria: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Sexo",
          align: "start",
          sortable: false,
          value: "sexo",
        },
        {
          text: "Clasificación",
          align: "start",
          sortable: false,
          value: "clasificacion",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],
      clasificacion: [
        { text: "Clasificación ternero", id: 1 },
        { text: "Clasificación desmamante", id: 2 },
        { text: "Clasificación después de desmamante", id: 3 },
        { text: "Clasificación adulta", id: 4 },
      ],

      // Administrar subcategorias animal
      editedSubCategoria: {
        idSubcategoriaAnimal: 0,
        esReproductivo: false,
        nombre: "",
        idCategoriaAnimal: 0,
      },
      defaultSubCategoria: {
        idSubcategoriaAnimal: 0,
        esReproductivo: false,
        nombre: "",
        idCategoriaAnimal: 0,
      },
      headerSubcategoria: [
        {
          text: "Categoría",
          align: "start",
          sortable: true,
          value: "categoriaAnimal.nombre",
        },
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Sexo",
          align: "start",
          sortable: false,
          value: "categoriaAnimal.sexo",
        },
        {
          text: "Rep.",
          align: "start",
          sortable: false,
          value: "esReproductivo",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],

      // Administrar parametros recategorizacion
      editedRec: {
        idTipoMovimientoAnimal: 0,
        nombre: "",
        reglasSalida: [],
        reglasEntrada: [],
      },
      defaultRec: {
        idTipoMovimientoAnimal: 0,
        nombre: "",
        reglasSalida: [],
        reglasEntrada: [],
      },
      headerRec: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Categoría",
          align: "start",
          sortable: false,
          value: "categoriaAnimal.nombre",
        },
        {
          text: "Sexo",
          align: "start",
          sortable: false,
          value: "categoriaAnimal.sexo",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],

      // Administrar métodos de reproduccion
      editedMetodoReproduccion: {
        idMetodoReproduccion: 0,
        nombre: "",
      },
      defaultMetodoReproduccion: {
        idMetodoReproduccion: 0,
        nombre: "",
      },
      headerMetodoReproduccion: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],

      // Administrar categorias de reproduccion
      editedCategoriaReproduccion: {
        idCategoriaReproduccion: 0,
        nombre: "",
      },
      defaultCategoriaReproduccion: {
        idCategoriaReproduccion: 0,
        nombre: "",
      },
      headerCategoriaReproduccion: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          value: "nombre",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ],

      // Index flags
      editedIndex: -1,

      subEditedIndex: -1,

      tipoEditedIndex: -1,

      categoriaEditedIndex: -1,

      subCategoriaEditedIndex: -1,

      recEditedIndex: -1,

      metRepEditedIndex: -1,

      catRepEditedIndex: -1,

      // dialog flags
      dialog: false,
      dialogDelete: false,

      subDialog: false,
      dialogSubDelete: false,

      tipoDialog: false,
      dialogTipoDelete: false,

      categoriaDialog: false,
      dialogCategoriaDelete: false,

      subCategoriaDialog: false,
      dialogSubCategoriaDelete: false,

      recDialog: false,
      dialogRecDelete: false,

      metRepDialog: false,
      dialogMetRepDelete: false,

      catRepDialog: false,
      dialogCatRepDelete: false,

      // Form variables and rules
      valid: false,
      saveDisabled: false,
      nombreLength: 30,
      commonRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          !v ||
          v.length <= this.nombreLength ||
          `No debe superar ${this.nombreLength} caracteres`,
      ],
      completeRules: [(v) => !!v || "Campo obligatorio"],
      completeMultipleRules: [
        (v) => !v || v.length !== 0 || "Debe haber por lo menos una entrada",
      ],
      nonNegativeRules: [
        (v) => !!v || "Campo obligatorio",
        (v) => v >= 0 || "No puede ser negativo",
        (v) => v <= 99999 || "Código muy largo",
      ],
      listaContenidoGraficos: [
        { anchorLink: "#conceptos", name: "Conceptos" },
        { anchorLink: "#subconceptos", name: "Subconceptos" },
        { anchorLink: "#tipomovimiento", name: "Tipos de movimientos" },
        { anchorLink: "#categoria", name: "Categorías de animales" },
        { anchorLink: "#subcategoria", name: "Subcategorías de animales" },
        { anchorLink: "#paramrec", name: "Parámetros de recategorización" },
        { anchorLink: "#metreproduccion", name: "Métodos de reproducción" },
        { anchorLink: "#catreproduccion", name: "Categorías de reproducción" },
      ],
    };
  },
  computed: {
    ...mapState("conceptos", [
      "conceptos",
      "subConceptos",
      "listaSubconceptos",
      "listaTipoMovimientoAnimal",
      "listaCategoriaAnimal",
      "listaSubCategoriaAnimal",
      "listaTipoMovimientoRecategorizacion",
      "listaParametrosRecategorizacion",
      "listaMetodoReproduccion",
      "listaCategoriaReproduccion",
    ]),
    ...mapState("session", ["isRestored"]),
    ...mapGetters("establecimientos", ["currentCategoria"]),
    ...mapGetters("conceptos", ["getSubconceptoById", "getConceptoById"]),
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Concepto" : "Editar Concepto";
    },
    formTitleSub() {
      return this.subEditedIndex === -1
        ? "Nuevo Subconcepto"
        : "Editar Subconcepto";
    },
    formTipoMovimientoTitle() {
      return this.tipoEditedIndex === -1
        ? "Nuevo tipo movimiento animal"
        : "Editar tipo movimiento animal";
    },
    formCategoriaTitle() {
      return this.categoriaEditedIndex === -1
        ? "Nueva categoría animal"
        : "Editar categoría animal";
    },
    formSubCategoriaTitle() {
      return this.subCategoriaEditedIndex === -1
        ? "Nueva subcategoría animal"
        : "Editar subcategoría animal";
    },
    formRecTitle() {
      return this.recEditedIndex === -1
        ? "Nuevo parám. recategorización"
        : "Editar parám. recategorización";
    },
    formMetodoReproduccionTitle() {
      return this.metRepEditedIndex === -1
        ? "Nuevo método de reproducción"
        : "Editar método de reproducción";
    },
    formCategoriaReproduccionTitle() {
      return this.catRepEditedIndex === -1
        ? "Nueva categoría de reproducción"
        : "Editar categoría de reproducción";
    },
    listaSubc() {
      return this.listaSubconceptos.map((sub) => {
        return {
          idSubconcepto: sub.idSubconcepto,
          soloCargaMovimientoFinciero: null,
          nombre: sub.nombre,
        };
      });
    },
    listaConceptosOrdenados() {
      let temp = cloneDeep(this.subConceptos);
      return temp.sort((first, second) => {
        if (
          first.subConceptos.length !== 0 &&
          second.subConceptos.length !== 0
        ) {
          if (first.subConceptos[0].codigo < second.subConceptos[0].codigo) {
            return -1;
          }
          if (second.subConceptos[0].codigo < first.subConceptos[0].codigo) {
            return 1;
          }
        }
        return 0;
      });
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    tab(val) {
      if (val === 1 || val === 0) {
        GlobalEventEmitter.$emit(
          "admin-ganaderia",
          this.listaContenidoGraficos
        );
      } else {
        GlobalEventEmitter.$emit("admin-agricultura");
      }
    },
  },
  methods: {
    ...mapActions("conceptos", [
      "fetchListaConceptos",
      "clearListaConceptos",
      "fetchListaSubConceptos",
      "clearListaSubConceptos",
      "fetchListaCategoriaAnimal",
      "fetchListaTipoMovimientoAnimal",
      "clearListaTipoMovimientoAnimal",
      "clearListaCategoriaAnimal",
      "fetchListaSubCategoriaAnimal",
      "clearListaSubCategoriaAnimal",
      "fetchListaTipoMovimientoRecategorizacion",
      "clearListaTipoMovimientoRecategorizacion",
      "fetchListaParametrosRecategorizacion",
      "clearListaParametrosRecategorizacion",
      "fetchListaMetodoReproduccion",
      "clearListaMetodoReproduccion",
      "fetchListaCategoriaReproduccion",
      "clearListaCategoriaReproduccion",
    ]),

    // Metodos de conceptos
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedConcepto = Object.assign({}, this.defaultConcepto);
        this.editedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedConcepto = Object.assign({}, this.defaultConcepto);
        this.editedIndex = -1;
      });
    },
    editConcepto(concepto) {
      this.editedIndex = this.conceptosSaved.indexOf(concepto);
      this.editedConcepto = Object.assign({}, concepto);
      this.dialog = true;
    },
    deleteConcepto(concepto) {
      this.editedIndex = this.conceptosSaved.indexOf(concepto);
      this.editedConcepto = Object.assign({}, concepto);
      this.dialogDelete = true;
    },
    deleteConceptoConfirm() {
      this.closeDelete();
    },
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.editedIndex > -1) {
            await ConfiguracionRepository.actualizarConcepto(
              this.editedConcepto.idConcepto,
              this.editedConcepto.tipo,
              this.editedConcepto.nombre
            );
          } else {
            await ConfiguracionRepository.crearConcepto(
              this.editedConcepto.tipo,
              this.editedConcepto.nombre
            );
          }
          this.editedConcepto = Object.assign({}, this.defaultConcepto);
          this.editedIndex = -1;
          this.conceptosSaved = [];

          this.clearListaConceptos();
          await this.fetchListaConceptos();
          this.conceptosSaved = this.conceptos.map((concepto) =>
            cloneDeep(concepto)
          );
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.close();
    },
    async saveAndCreateConcepto() {
      await this.save();
      this.dialog = true;
      setTimeout(() => {
        this.$refs.conceptoref.focus();
      });
    },

    // Metodos de subconceptos
    closeDeleteSub() {
      this.dialogSubDelete = false;
      this.$nextTick(() => {
        this.editedSubConcepto = Object.assign({}, this.defaultSubConcepto);
        this.subEditedIndex = -1;
      });
    },
    closeSubConcepto() {
      this.subDialog = false;
      this.$nextTick(() => {
        this.editedSubConcepto = Object.assign({}, this.defaultSubConcepto);
        this.subEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    editSubConcepto(concepto, subConcepto) {
      let indexConcepto = this.subConceptosSaved.findIndex(
        (con) => con.idConcepto === concepto.idConcepto
      );

      this.subEditedIndex = this.subConceptosSaved[
        indexConcepto
      ].subConceptos.findIndex(
        (sub) => sub.idSubconcepto === subConcepto.idSubconcepto
      );

      subConcepto.indicarParcela =
        subConcepto.indicarParcela === 1 ? true : false;
      subConcepto.esRelacionadoProduccion =
        subConcepto.esRelacionadoProduccion === 1 ? true : false;
      this.editedSubConcepto = Object.assign({}, subConcepto);
      this.subDialog = true;
    },
    deleteSubConcepto(concepto, subConcepto) {
      let indexConcepto = this.subConceptosSaved.findIndex(
        (con) => con.idConcepto === concepto.idConcepto
      );

      this.subEditedIndex = this.subConceptosSaved[
        indexConcepto
      ].subConceptos.findIndex(
        (sub) => sub.idSubconcepto === subConcepto.idSubconcepto
      );

      subConcepto.indicarParcela =
        subConcepto.indicarParcela === 1 ? true : false;
      this.editedSubConcepto = Object.assign({}, subConcepto);
      this.dialogSubDelete = true;
    },
    async deleteSubConceptoConfirm() {
      await ConfiguracionRepository.debajaSubConcepto(
        this.editedSubConcepto.idSubconcepto
      );

      this.clearListaSubConceptos();
      await this.fetchListaSubConceptos();
      this.subConceptosSaved = this.subConceptos.map((sub) => cloneDeep(sub));
      this.closeDeleteSub();
    },
    async saveAndCreateSub() {
      await this.saveSubConcepto();
      this.subDialog = true;
      setTimeout(() => {
        this.$refs.selectConcepto.focus();
      });
    },
    async saveSubConcepto() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
        }

        if (this.subEditedIndex > -1) {
          await ConfiguracionRepository.actualizarSubConcepto(
            this.editedSubConcepto.idSubconcepto,
            this.editedSubConcepto.idConcepto,
            this.editedSubConcepto.codigo,
            this.editedSubConcepto.esRelacionadoProduccion,
            this.editedSubConcepto.indicarParcela === 1 ? true : false,
            this.editedSubConcepto.nombre
          );
        } else {
          await ConfiguracionRepository.crearSubConcepto(
            this.editedSubConcepto.idConcepto,
            this.editedSubConcepto.codigo,
            this.editedSubConcepto.esRelacionadoProduccion,
            this.editedSubConcepto.indicarParcela,
            this.editedSubConcepto.nombre
          );
        }
        this.editedSubConcepto = Object.assign({}, this.defaultSubConcepto);
        this.subEditedIndex = -1;
        this.subConceptosSaved = [];

        this.clearListaSubConceptos();
        await this.fetchListaSubConceptos();
        this.subConceptosSaved = this.subConceptos.map((sub) => cloneDeep(sub));
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeSubConcepto();
    },
    getSubConceptos(idConcepto) {
      if (this.subConceptosSaved.length !== 0) {
        let subs = this.subConceptosSaved.find(
          (sub) => sub.idConcepto === idConcepto
        )?.subConceptos;
        return subs ? subs : [];
      }
    },

    // Metodos de Tipo Movimiento
    editTipoMovimiento(tipoMovimiento) {
      this.tipoEditedIndex = this.listaTipoMovimientoAnimal.findIndex(
        (mov) =>
          mov.idTipoMovimientoAnimal === tipoMovimiento.idTipoMovimientoAnimal
      );
      this.editedTipoMovimiento = Object.assign({}, tipoMovimiento);
      this.editedTipoMovimiento.indicarImporte =
        this.editedTipoMovimiento.indicarImporte === 1 ? true : false;
      if (
        Array.isArray(this.editedTipoMovimiento.parametrosMovAnimalFinanciero)
      ) {
        this.editedTipoMovimiento.subconceptosImporte = [];
        this.editedTipoMovimiento.parametrosMovAnimalFinanciero.map((param) => {
          let subconcepto = this.getSubconceptoById(param.idSubconcepto);
          if (subconcepto) {
            let temp = {
              idSubconcepto: param.idSubconcepto,
              soloCargaMovimientoFinciero:
                param.tipoIngreso === 1 ? false : true,
              nombre: subconcepto.nombre,
            };
            this.$set(
              this.editedTipoMovimiento.subconceptosImporte,
              this.editedTipoMovimiento.subconceptosImporte.length,
              temp
            );
          }
        });
      }
      this.tipoDialog = true;
    },
    async saveTipo() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          let subconceptosRelacionados = [];
          subconceptosRelacionados =
            this.editedTipoMovimiento.subconceptosImporte.map((sub) => {
              let retObj = {};
              if (sub?.soloCargaMovimientoFinciero) {
                retObj = {
                  idSubconcepto: sub.idSubconcepto,
                  soloCargaMovimientoFinciero: sub.soloCargaMovimientoFinciero,
                };
              } else {
                retObj = {
                  idSubconcepto: sub.idSubconcepto,
                  soloCargaMovimientoFinciero: false,
                };
              }
              return retObj;
            });
          if (this.tipoEditedIndex > -1) {
            await ConfiguracionRepository.actualizarTipoMovimientoAnimal(
              this.editedTipoMovimiento.idTipoMovimientoAnimal,
              this.editedTipoMovimiento.codigo,
              this.editedTipoMovimiento.tipo,
              this.editedTipoMovimiento.nombre,
              this.editedTipoMovimiento.indicarImporte,
              subconceptosRelacionados
            );
          } else {
            await ConfiguracionRepository.agregarTipoMovimientoAnimal(
              this.editedTipoMovimiento.codigo,
              this.editedTipoMovimiento.tipo,
              this.editedTipoMovimiento.nombre,
              this.editedTipoMovimiento.indicarImporte,
              subconceptosRelacionados
            );
          }
          this.editedTipoMovimiento = Object.assign(
            {},
            this.defaultTipoMovimiento
          );
          this.tipoEditedIndex = -1;

          this.clearListaTipoMovimientoAnimal();
          await this.fetchListaTipoMovimientoAnimal();

          this.clearListaSubConceptos();
          await this.fetchListaSubConceptos();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeTipo();
    },
    closeTipo() {
      this.tipoDialog = false;
      this.$nextTick(() => {
        this.editedTipoMovimiento = Object.assign(
          {},
          this.defaultTipoMovimiento
        );
        this.tipoEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteTipoMovimientoAnimal(tipoMovimiento) {
      this.tipoEditedIndex = this.listaTipoMovimientoAnimal.findIndex(
        (mov) =>
          mov.idTipoMovimientoAnimal === tipoMovimiento.idTipoMovimientoAnimal
      );
      this.editedTipoMovimiento = Object.assign({}, tipoMovimiento);
      this.dialogTipoDelete = true;
    },
    closeTipoDelete() {
      this.dialogTipoDelete = false;
      this.$nextTick(() => {
        this.editedTipoMovimiento = Object.assign(
          {},
          this.defaultTipoMovimiento
        );
        this.tipoEditedIndex = -1;
      });
    },
    async deleteTipoConfirm() {
      await ConfiguracionRepository.borrarTipoMovimientoAnimal(
        this.editedTipoMovimiento.idTipoMovimientoAnimal
      );
      this.clearListaTipoMovimientoAnimal();
      await this.fetchListaTipoMovimientoAnimal();
      this.closeTipoDelete();
    },
    async saveAndCreateTipo() {
      await this.saveTipo();
      this.tipoDialog = true;
      setTimeout(() => {
        this.$refs.tiporef.focus();
      });
    },
    removeSubconcepto(item) {
      const index = this.editedTipoMovimiento.subconceptosImporte.findIndex(
        (sub) => sub.idSubconcepto === item.idSubconcepto
      );
      if (index >= 0) {
        // this.editedTipoMovimiento.subconceptosImporte.splice(index, 1)
        this.$delete(this.editedTipoMovimiento.subconceptosImporte, index);
        this.t++;
      }
    },

    // Metodos de Categoria Animal
    editCategoria(categoria) {
      this.categoriaEditedIndex = this.listaCategoriaAnimal.findIndex(
        (cat) => cat.idCategoriaAnimal === categoria.idCategoriaAnimal
      );
      this.editedCategoria = Object.assign({}, categoria);
      this.categoriaDialog = true;
    },
    closeCategoria() {
      this.categoriaDialog = false;
      this.$nextTick(() => {
        this.editedCategoria = Object.assign({}, this.defaultCategoria);
        this.categoriaEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteCategoria(categoria) {
      this.categoriaEditedIndex = this.listaCategoriaAnimal.findIndex(
        (cat) => cat.idCategoriaAnimal === categoria.idCategoriaAnimal
      );
      this.editedCategoria = Object.assign({}, categoria);
      this.dialogCategoriaDelete = true;
    },
    closeCategoriaDelete() {
      this.dialogCategoriaDelete = false;
      this.$nextTick(() => {
        this.editedCategoria = Object.assign({}, this.defaultCategoria);
        this.categoriaEditedIndex = -1;
      });
    },
    async deleteCategoriaConfirm() {
      await ConfiguracionRepository.borrarCategoriaAnimal(
        this.editedCategoria.idCategoriaAnimal
      );
      this.clearListaCategoriaAnimal();
      await this.fetchListaCategoriaAnimal();
      this.closeCategoriaDelete();
    },
    async saveCategoria() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.categoriaEditedIndex > -1) {
            await ConfiguracionRepository.actualizarCategoriaAnimal(
              this.editedCategoria.idCategoriaAnimal,
              this.editedCategoria.clasificacion,
              this.editedCategoria.sexo,
              this.editedCategoria.nombre
            );
          } else {
            await ConfiguracionRepository.agregarCategoriaAnimal(
              this.editedCategoria.clasificacion,
              this.editedCategoria.sexo,
              this.editedCategoria.nombre
            );
          }
          this.editedCategoria = Object.assign({}, this.defaultCategoria);
          this.categoriaEditedIndex = -1;

          this.clearListaCategoriaAnimal();
          await this.fetchListaCategoriaAnimal();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeCategoria();
    },
    async saveAndCreateCategorias() {
      await this.saveCategoria();
      this.categoriaDialog = true;
      setTimeout(() => {
        this.$refs.categoriasref.focus();
      });
    },

    // Metodos de SubCategoria Animal
    editSubcategoria(subcategoria) {
      this.subCategoriaEditedIndex = this.listaSubCategoriaAnimal.findIndex(
        (subcat) =>
          subcat.idSubcategoriaAnimal === subcategoria.idSubcategoriaAnimal
      );
      this.editedSubCategoria = Object.assign({}, subcategoria);
      this.editedSubCategoria.esReproductivo =
        this.editedSubCategoria.esReproductivo === 1 ? true : false;
      this.subCategoriaDialog = true;
    },
    closeSubcategoria() {
      this.subCategoriaDialog = false;
      this.$nextTick(() => {
        this.editedSubCategoria = Object.assign({}, this.defaultSubCategoria);
        this.subCategoriaEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteSubcategoria(subcategoria) {
      this.subCategoriaEditedIndex = this.listaSubCategoriaAnimal.findIndex(
        (subcat) =>
          subcat.idSubcategoriaAnimal === subcategoria.idSubcategoriaAnimal
      );
      this.editedSubCategoria = Object.assign({}, subcategoria);
      this.dialogSubCategoriaDelete = true;
    },
    closeSubcategoriaDelete() {
      this.dialogSubCategoriaDelete = false;
      this.$nextTick(() => {
        this.editedSubCategoria = Object.assign({}, this.defaultSubCategoria);
        this.subCategoriaEditedIndex = -1;
      });
    },
    async deleteSubcategoriaConfirm() {
      await ConfiguracionRepository.borrarSubCategoriaAnimal(
        this.editedSubCategoria.idSubcategoriaAnimal
      );
      this.clearListaSubCategoriaAnimal();
      await this.fetchListaSubCategoriaAnimal();
      this.closeSubcategoriaDelete();
    },
    async saveSubcategoria() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.subCategoriaEditedIndex > -1) {
            await ConfiguracionRepository.actualizarSubCategoriaAnimal(
              this.editedSubCategoria.idSubcategoriaAnimal,
              this.editedSubCategoria.idCategoriaAnimal,
              this.editedSubCategoria.esReproductivo,
              this.editedSubCategoria.nombre
            );
          } else {
            await ConfiguracionRepository.agregarSubCategoriaAnimal(
              this.editedSubCategoria.idCategoriaAnimal,
              this.editedSubCategoria.esReproductivo,
              this.editedSubCategoria.nombre
            );
          }
          this.editedSubCategoria = Object.assign({}, this.defaultSubCategoria);
          this.subCategoriaEditedIndex = -1;

          this.clearListaSubCategoriaAnimal();
          await this.fetchListaSubCategoriaAnimal();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeSubcategoria();
    },
    async saveAndCreateSubcategoria() {
      await this.saveSubcategoria();
      this.subCategoriaDialog = true;
      setTimeout(() => {
        this.$refs.subcategoriaref.focus();
      });
    },

    // Metodos de Parametros de Recategorizacion
    editarRec(param) {
      this.recEditedIndex = this.listaParametrosRecategorizacion.findIndex(
        (p) =>
          p.idParametroRecategorizacion === param.idParametroRecategorizacion
      );
      this.editedRec = cloneDeep(param);
      this.editedRec.reglasEntrada = [];
      this.editedRec.reglasSalida = [];
      for (let index = 0; index < this.editedRec.reglas.length; index++) {
        let regla = this.editedRec.reglas[index];
        if (regla.tipo === 2) {
          this.editedRec.reglasSalida.push(regla.idCategoriaAnimal);
        } else if (regla.tipo === 1) {
          this.editedRec.reglasEntrada.push(regla.idCategoriaAnimal);
        }
      }
      this.recDialog = true;
    },
    closeRec() {
      this.recDialog = false;
      this.$nextTick(() => {
        this.editedRec = cloneDeep(this.defaultRec);
        this.recEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteRec(param) {
      this.recEditedIndex = this.listaParametrosRecategorizacion.findIndex(
        (p) =>
          p.idParametroRecategorizacion === param.idParametroRecategorizacion
      );
      this.editedRec = cloneDeep(param);
      this.dialogRecDelete = true;
    },
    closeRecDelete() {
      this.dialogRecDelete = false;
      this.$nextTick(() => {
        this.editedRec = cloneDeep(this.defaultRec);
        this.recEditedIndex = -1;
      });
    },
    async deleteRecConfirm() {
      await ConfiguracionRepository.borrarParametroRecategorizacion(
        this.editedRec.idParametroRecategorizacion
      );
      this.clearListaParametrosRecategorizacion();
      await this.fetchListaParametrosRecategorizacion();
      this.closeRecDelete();
    },
    async saveRec() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          const reglas = [];
          for (
            let index = 0;
            index < this.editedRec.reglasSalida.length;
            index++
          ) {
            let regla = this.editedRec.reglasSalida[index];
            reglas.push({ idCategoriaAnimal: regla, tipo: 2 });
          }
          for (
            let index = 0;
            index < this.editedRec.reglasEntrada.length;
            index++
          ) {
            let regla = this.editedRec.reglasEntrada[index];
            reglas.push({ idCategoriaAnimal: regla, tipo: 1 });
          }
          if (this.recEditedIndex > -1) {
            await ConfiguracionRepository.actualizarParametroRecategorizacion(
              this.editedRec.idParametroRecategorizacion,
              this.editedRec.idTipoMovimientoAnimal,
              this.editedRec.nombre,
              reglas
            );
          } else {
            await ConfiguracionRepository.crearParametroRecategorizacion(
              this.editedRec.idTipoMovimientoAnimal,
              this.editedRec.nombre,
              reglas
            );
          }
          this.editedRec = cloneDeep(this.defaultRec);
          this.recEditedIndex = -1;

          this.clearListaParametrosRecategorizacion();
          await this.fetchListaParametrosRecategorizacion();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeRec();
    },
    async saveAndCreateRec() {
      await this.saveRec();
      this.recDialog = true;
      setTimeout(() => {
        this.$refs.recparam.focus();
      });
    },
    removeEntrada(item) {
      const index = this.editedRec.reglasEntrada.indexOf(
        item.idCategoriaAnimal
      );
      if (index >= 0) this.editedRec.reglasEntrada.splice(index, 1);
    },
    removeSalida(item) {
      const index = this.editedRec.reglasSalida.indexOf(item.idCategoriaAnimal);
      if (index >= 0) this.editedRec.reglasSalida.splice(index, 1);
    },

    // Metodos de Metodos de Reproduccion
    editMetodoReproduccion(metodo) {
      this.metRepEditedIndex = this.listaMetodoReproduccion.findIndex(
        (met) => met.idMetodoReproduccion === metodo.idMetodoReproduccion
      );
      this.editedMetodoReproduccion = Object.assign({}, metodo);
      this.metRepDialog = true;
    },
    closeMetRep() {
      this.metRepDialog = false;
      this.$nextTick(() => {
        this.editedMetodoReproduccion = Object.assign(
          {},
          this.defaultMetodoReproduccion
        );
        this.metRepEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteMetReproduccion(metodo) {
      this.metRepEditedIndex = this.listaMetodoReproduccion.findIndex(
        (met) => met.idMetodoReproduccion === metodo.idMetodoReproduccion
      );
      this.editedMetodoReproduccion = Object.assign({}, metodo);
      this.dialogMetRepDelete = true;
    },
    closeMetRepDelete() {
      this.dialogMetRepDelete = false;
      this.$nextTick(() => {
        this.editedMetodoReproduccion = Object.assign(
          {},
          this.defaultMetodoReproduccion
        );
        this.metRepEditedIndex = -1;
      });
    },
    async deleteMetRepConfirm() {
      await ConfiguracionRepository.borrarMetodoReproduccion(
        this.editedMetodoReproduccion.idMetodoReproduccion
      );
      this.clearListaMetodoReproduccion();
      await this.fetchListaMetodoReproduccion();
      this.closeMetRepDelete();
    },
    async saveMetRep() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.metRepEditedIndex > -1) {
            await ConfiguracionRepository.actualizarMetodoReproduccion(
              this.editedMetodoReproduccion.idMetodoReproduccion,
              this.editedMetodoReproduccion.nombre
            );
          } else {
            await ConfiguracionRepository.crearMetodoReproduccion(
              this.editedMetodoReproduccion.nombre
            );
          }
          this.editedMetodoReproduccion = Object.assign(
            {},
            this.defaultMetodoReproduccion
          );
          this.metRepEditedIndex = -1;

          this.clearListaMetodoReproduccion();
          await this.fetchListaMetodoReproduccion();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeMetRep();
    },
    async saveAndCreateMetRep() {
      await this.saveMetRep();
      this.metRepDialog = true;
      setTimeout(() => {
        this.$refs.metref.focus();
      });
    },

    // Metodos de categorias de reproduccion
    editCategoriaReproduccion(categoria) {
      this.catRepEditedIndex = this.listaCategoriaReproduccion.findIndex(
        (cat) =>
          cat.idCategoriaReproduccion === categoria.idCategoriaReproduccion
      );
      this.editedCategoriaReproduccion = Object.assign({}, categoria);
      this.catRepDialog = true;
    },
    closeCatRep() {
      this.catRepDialog = false;
      this.$nextTick(() => {
        this.editedCategoriaReproduccion = Object.assign(
          {},
          this.defaultCategoriaReproduccion
        );
        this.catRepEditedIndex = -1;
      });
      this.$refs.form.resetValidation();
    },
    deleteCatReproduccion(categoria) {
      this.catRepEditedIndex = this.listaCategoriaReproduccion.findIndex(
        (cat) =>
          cat.idCategoriaReproduccion === categoria.idCategoriaReproduccion
      );
      this.editedCategoriaReproduccion = Object.assign({}, categoria);
      this.dialogCatRepDelete = true;
    },
    closeCatRepDelete() {
      this.dialogCatRepDelete = false;
      this.$nextTick(() => {
        this.editedCategoriaReproduccion = Object.assign(
          {},
          this.defaultCategoriaReproduccion
        );
        this.catRepEditedIndex = -1;
      });
    },
    async deleteCatRepConfirm() {
      await ConfiguracionRepository.debajaCategoriaReproduccion(
        this.editedCategoriaReproduccion.idCategoriaReproduccion
      );
      this.clearListaCategoriaReproduccion();
      await this.fetchListaCategoriaReproduccion();
      this.closeCatRepDelete();
    },
    async saveCatRep() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }

        if (!this.saveDisabled) {
          this.saveDisabled = true;
          if (this.catRepEditedIndex > -1) {
            await ConfiguracionRepository.actualizarCategoriaReproduccion(
              this.editedCategoriaReproduccion.idCategoriaReproduccion,
              this.editedCategoriaReproduccion.nombre
            );
          } else {
            await ConfiguracionRepository.crearCategoriaReproduccion(
              this.editedCategoriaReproduccion.nombre
            );
          }
          this.editedCategoriaReproduccion = Object.assign(
            {},
            this.defaultCategoriaReproduccion
          );
          this.catRepEditedIndex = -1;

          this.clearListaCategoriaReproduccion();
          await this.fetchListaCategoriaReproduccion();
        }
      } catch (e) {
        this.saveDisabled = false;
      }
      this.saveDisabled = false;
      this.closeCatRep();
    },
    async saveAndCreateCatRep() {
      await this.saveCatRep();
      this.catRepDialog = true;
      setTimeout(() => {
        this.$refs.catref.focus();
      });
    },
    // intersected(item){
    //   this.$router.replace({ name: this.$route.name, hash: `#${item}` }).catch(() => {})
    // }
  },
  beforeDestroy() {
    GlobalEventEmitter.$emit("content-drawer", []);
  },
  async created() {
    while (!this.isRestored) {
      await this.$sleep(10);
    }

    await this.fetchListaTipoMovimientoAnimal();
    await this.fetchListaCategoriaAnimal();
    await this.fetchListaSubCategoriaAnimal();
    await this.fetchListaTipoMovimientoRecategorizacion();
    await this.fetchListaParametrosRecategorizacion();
    await this.fetchListaMetodoReproduccion();
    await this.fetchListaCategoriaReproduccion();

    // await this.fetchListaConceptos()
    this.conceptosSaved = this.conceptos.map((concepto) => cloneDeep(concepto));

    // await this.fetchListaSubConceptos()
    this.subConceptosSaved = this.subConceptos.map((sub) => cloneDeep(sub));
    this.tab = this.currentCategoria === 2 ? 1 : 0;
  },
};
</script>

<style scoped>
.fh-scroll {
  overflow: auto;
}
th,
td {
  border: 1px solid lightgrey;
  padding-left: 8px !important;
  padding-right: 8px !important;
}

tr {
  height: 30px;
}

table {
  border-collapse: collapse;
}

.fh-empty-row {
  border: none;
  background-color: white;
  height: 23px;
}
</style>
